import script from "./BB.vue?vue&type=script&lang=js"
export * from "./BB.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__